import { IPlayUIStateProps } from "../..";
import { IThemeMapStateProps } from "./Theme";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IThemeMapStateProps => ({
  theme: state.theme.theme
});
